var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-edit",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "url(#pattern-edit)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-edit)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.5,
    y: -3.59998,
    width: 35.1,
    height: 35.1,
    rx: 17.55,
    fill: "#25537E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-edit",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-edit",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-edit",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.03d9694313c4700529a9b6f276569bc6.svg";
export { ForwardRef as ReactComponent };